import React from 'react';
import './Footer.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { isIOS } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhoneAlt, faMapMarked, faCopyright, faMobileAlt } from '@fortawesome/free-solid-svg-icons'
import { forwardTo } from '../../helpers'



export const FooterComponent_430e = props => {
    const handleOpenAPPUrl = () => {
        if (isIOS) {
            window.open('https://apps.apple.com/es/app/gecor/id1127259219')
        } else {
            window.open('https://play.google.com/store/apps/details?id=com.gecorsystem.gecorn&hl=es&gl=US')
        }
    };

    return (
        <div id="footer430">
            <footer >
                <div className="footer-top">
                    <Container>
                        <Row>
                            <Col sm={6}>
                                <div className="footer-about">
                                    <Row>
                                        <h3 className="footer-informacion-Ln">Concejalía de Sostenibilidad, Movilidad y Renovables</h3>
                                    </Row>
                                    <p><FontAwesomeIcon icon={faMapMarked} /> C/ Los Robles, s/n (Edificio Teatro Buero Vallejo) 28921 Alcorcón</p>
                                    <p><FontAwesomeIcon icon={faPhoneAlt} /> 911 12 79 00</p>
                                    <p><FontAwesomeIcon icon={faEnvelope} /> sostenibilidad@ayto-alcorcon.es</p>
                                    <p><FontAwesomeIcon icon={faCopyright} /> Powered by GECOR.</p>
                                </div>
                            </Col>
                            <Col sm={6}>
                                <div className="badge-ln text-left">
                                    <Row>
                                        <h3>Consultas</h3>
                                    </Row>
                                    <Row>
                                        Recuerde que puede hacer sus consultas a través de:
                                    </Row>
                                    <p className="enlace" onClick={() => forwardTo('/alcorcon/contacto-medioambiente')}><FontAwesomeIcon icon={faEnvelope} /> Correo Electrónico</p>
                                    <p className="enlace" onClick={handleOpenAPPUrl}><FontAwesomeIcon icon={faMobileAlt} /> App</p>
                                    <hr />
                                    <Row>
                                        Y también llamando a los teléfonos gratuitos:
                                    </Row>
                                    <p><FontAwesomeIcon icon={faPhoneAlt} /> 965 00 00 00</p>
                                    <p><FontAwesomeIcon icon={faPhoneAlt} /> 965 10 00 00</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </footer>
        </div >
    );
}

export default FooterComponent_430e;